export default __webpack_public_path__ + "static/media/(Fast)Wall Outlet (BS1363).503b4cb3.svg";